import axios from 'axios'

export default async function ( { next } ) {
    const ErrorClient = axios.create()
    await ErrorClient.get(`${process.env.VUE_APP_API}/utils/checkHealth`).then(
        (response) => {
            if(response.status === 200) {
                return ('/serverEncounteredError')
            } else {
                throw true
            }
        }
    ).catch((error) => {
        if(error) {
            return next()
        }
    })
}
